import { Box, Chip, Skeleton, Stack, Typography } from "@mui/material";

import { SuggestedPrompt } from "./api";

interface Props {
  prompts: SuggestedPrompt[];
  loading?: boolean;
  onPick: (prompt: string) => void;
}

const SKELETON_WIDTHS = [140, 180, 110];

const SuggestedPrompts = ({ prompts, loading, onPick }: Props) => {
  if (!loading && prompts.length === 0) return null;
  return (
    <Box>
      <Typography
        sx={{
          fontSize: 11,
          color: "#4A5565",
          mb: 1.5,
          fontWeight: 600,
          textTransform: "uppercase",
          letterSpacing: 0.4,
        }}
      >
        Try asking
      </Typography>
      <Stack direction="row" flexWrap="wrap" gap={0.75}>
        {prompts.map((p, i) => (
          <Chip
            key={i}
            label={p.label}
            onClick={() => onPick(p.prompt)}
            size="small"
            sx={{
              backgroundColor: "white",
              border: "1px solid rgba(0,0,0,0.1)",
              color: "#0a0a0a",
              fontSize: 12,
              cursor: "pointer",
              height: "auto",
              py: 0.5,
              "& .MuiChip-label": {
                whiteSpace: "normal",
                lineHeight: 1.3,
                px: 1,
              },
              "&:hover": {
                backgroundColor: "#f2f3fe",
                borderColor: "#8084FF",
              },
            }}
          />
        ))}
        {loading &&
          SKELETON_WIDTHS.map((width, i) => (
            <Skeleton
              key={`skeleton-${i}`}
              animation="wave"
              variant="rounded"
              width={width}
              height={28}
              sx={{ borderRadius: "16px" }}
            />
          ))}
      </Stack>
    </Box>
  );
};

export default SuggestedPrompts;
